"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("../../../../../extends-fa579b0f.js"),
  a = require("../../../../../objectWithoutProperties-2581b642.js"),
  t = require("../../../../../getPrototypeOf-6e942d92.js"),
  r = require("react"),
  c = require("classnames");
function l(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
require("../../../../../_commonjsHelpers-f10b257f.js"), require("../../../../../toPropertyKey-ec4a2a72.js");
var n = l(r),
  o = l(c),
  f = ["className", "svgRef"];
function i(e) {
  var a = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      c = t._getPrototypeOf(e);
    if (a) {
      var l = t._getPrototypeOf(this).constructor;
      r = Reflect.construct(c, arguments, l);
    } else r = c.apply(this, arguments);
    return t._possibleConstructorReturn(this, r);
  };
}
var s = function (r) {
  t._inherits(l, r);
  var c = i(l);
  function l() {
    return t._classCallCheck(this, l), c.apply(this, arguments);
  }
  return t._createClass(l, [{
    key: "render",
    value: function value() {
      var t = this.props,
        r = t.className,
        c = t.svgRef,
        l = a._objectWithoutProperties(t, f);
      return n["default"].createElement("svg", e._extends({
        width: "94.87",
        height: "95.58",
        viewBox: "0 0 94.87 95.58",
        fill: "currentColor",
        className: o["default"]("nmx-icon", r),
        ref: c
      }, l), n["default"].createElement("path", {
        fill: "#ffb81c",
        d: "M79.81 48.22a1.25 1.25 0 0 1 .13 2.49h-1.88a1.25 1.25 0 0 1-.13-2.49ZM72.19 48.22h-3.42a1.25 1.25 0 0 0 0 2.5h3.42a1.25 1.25 0 0 0 0-2.5Zm-9.29 0h-2a10.36 10.36 0 0 0-1.67.14 1.253 1.253 0 0 0 .42 2.47 7.54 7.54 0 0 1 1.25-.11h2a1.25 1.25 0 0 0 0-2.5ZM53.53 51.59A9.72 9.72 0 0 0 51.59 55a1.25 1.25 0 0 0 2.37.78 7.56 7.56 0 0 1 1.45-2.54 1.24 1.24 0 0 0-.11-1.76 1.25 1.25 0 0 0-1.77.11Zm-1.76 10a9.79 9.79 0 0 0 2.12 3.29 1.26 1.26 0 0 0 1.77.12 1.25 1.25 0 0 0 .12-1.76.47.47 0 0 0-.1-.1 7.11 7.11 0 0 1-1.58-2.46 1.25 1.25 0 0 0-2.33.91Zm8.06 6.21a10 10 0 0 0 1.09.07h2.49a1.25 1.25 0 0 0 0-2.5h-2.49a7.34 7.34 0 0 1-.81-.05 1.25 1.25 0 1 0-.42 2.46Zm9.45.07h3.42a1.25 1.25 0 0 0 0-2.5h-3.42a1.25 1.25 0 0 0 0 2.5Zm9.29 0h1.2a12.17 12.17 0 0 1 2 .16 1.251 1.251 0 1 0 .4-2.47 15.09 15.09 0 0 0-2.42-.19h-1.2a1.25 1.25 0 0 0 0 2.5Zm8.17 2.11a12.56 12.56 0 0 1 2.36 2 1.25 1.25 0 0 0 1.76.09 1.26 1.26 0 0 0 .09-1.77 15.27 15.27 0 0 0-2.83-2.43 1.24 1.24 0 0 0-1.72.33 1.27 1.27 0 0 0 .29 1.76h.06Zm5 6.64a12.26 12.26 0 0 1 .58 3.06 1.26 1.26 0 0 0 1.25 1.26 1.24 1.24 0 0 0 1.25-1.24.91.91 0 0 0 0-.17 14.77 14.77 0 0 0-.68-3.67 1.254 1.254 0 0 0-2.39.76ZM91.5 85a12.1 12.1 0 0 1-1.48 2.74 1.25 1.25 0 0 0 .58 1.67 1.23 1.23 0 0 0 1.42-.23 14.64 14.64 0 0 0 1.77-3.28 1.25 1.25 0 1 0-2.29-1v.1Zm-5.43 6.35a12.48 12.48 0 0 1-2.86 1.23 1.25 1.25 0 1 0 .58 2.43h.11a14.67 14.67 0 0 0 3.43-1.47 1.25 1.25 0 0 0 .45-1.71 1.26 1.26 0 0 0-1.69-.42Zm-8.37 1.71h-3.4a1.25 1.25 0 0 0 0 2.5h3.42a1.25 1.25 0 1 0 0-2.5Zm-9.29 0H65a1.25 1.25 0 1 0 0 2.5h3.42a1.25 1.25 0 0 0 0-2.5Zm-9.29 0h-3.4a1.25 1.25 0 0 0 0 2.5h3.42a1.25 1.25 0 0 0 0-2.5Zm-9.29 0h-3.4a1.25 1.25 0 0 0 0 2.5h3.42a1.25 1.25 0 0 0 0-2.5Zm-9.29 0h-3.4a1.25 1.25 0 0 0 0 2.5h3.42a1.25 1.25 0 0 0 0-2.5Zm-9.29 0h-3.4a1.25 1.25 0 0 0 0 2.5h3.42a1.25 1.25 0 0 0 0-2.5ZM22.35 93.09a1.25 1.25 0 0 1 .13 2.49h-1.85a1.25 1.25 0 0 1-.13-2.49Z",
        className: "icon-fill icon-accent"
      }), n["default"].createElement("path", {
        fill: "#fff",
        d: "M22.06 29.5A22.06 22.06 0 0 0 0 51.56c0 7.06 3.48 15.07 9.38 23.53a105.61 105.61 0 0 0 10.53 12.78l.89.9.39.38a1.23 1.23 0 0 0 1.74 0l.56-.56.36-.37.64-.66.67-.71c.12-.12.23-.25.35-.38l.72-.79a105.49 105.49 0 0 0 7.24-8.83c4.34-5.93 7.6-11.77 9.31-17.28a26.84 26.84 0 0 0 1.34-8 22.06 22.06 0 0 0-22-22.08Zm0 2.5a19.56 19.56 0 0 1 19.57 19.56 24.69 24.69 0 0 1-1.22 7.28c-1.62 5.21-4.75 10.81-9 16.54a104.25 104.25 0 0 1-7.07 8.63l-.7.77-.63.71-.64.67-.3.32-.36-.36a104 104 0 0 1-10.27-12.47c-5.63-8.07-8.93-15.66-8.93-22.09A19.56 19.56 0 0 1 22.07 32Z",
        className: "icon-fill icon-base"
      }), n["default"].createElement("path", {
        fill: "#ffb81c",
        d: "M22.06 39.29a12 12 0 1 0 12 12 12 12 0 0 0-12-12Zm0 2.5a9.48 9.48 0 1 1-9.43 9.5 9.5 9.5 0 0 1 9.43-9.51Z",
        className: "icon-fill icon-accent"
      }), n["default"].createElement("path", {
        fill: "#fff",
        d: "M78.35 0a16.52 16.52 0 0 0-16.51 16.5 20.39 20.39 0 0 0 1 6 45.34 45.34 0 0 0 6.88 12.79 83.32 83.32 0 0 0 5.33 6.5l.62.68.3.32.57.6.63.64.32.32a1.25 1.25 0 0 0 1.74 0l.6-.6.47-.48.5-.53.54-.58.56-.63.6-.66a76.36 76.36 0 0 0 5.2-6.56c4.5-6.37 7.17-12.42 7.17-17.78A16.51 16.51 0 0 0 78.36.02Zm0 2.5a14 14 0 0 1 14 14c0 4.72-2.48 10.35-6.71 16.34a74.46 74.46 0 0 1-5 6.34l-.29.33-.56.63-.53.58-.5.53-.38.39-.57-.6-.29-.31-.6-.65a77.82 77.82 0 0 1-5.16-6.3 42.6 42.6 0 0 1-6.51-12 17.84 17.84 0 0 1-.91-5.28 14 14 0 0 1 14-14Z",
        className: "icon-fill icon-base"
      }), n["default"].createElement("path", {
        fill: "#ffb81c",
        d: "M78.35 7.17a9.12 9.12 0 1 0 9.12 9.12 9.12 9.12 0 0 0-9.12-9.12Zm0 2.5a6.62 6.62 0 1 1-6.62 6.62 6.62 6.62 0 0 1 6.62-6.62Z",
        className: "icon-fill icon-accent"
      }));
    }
  }]), l;
}(n["default"].PureComponent);
s.displayName = "TwoMapPinsConnectedWithCurvyDottedLineIcon", module.exports = s;